import { useMutation } from "react-query";
import api from "../../client";
import {
  CreateInstitutionRankingPayload,
  InstitutionRanking,
} from "../../types/institution-ranking";

const postData = async (
  payload: CreateInstitutionRankingPayload,
): Promise<InstitutionRanking> => {
  const { data } = await api.post(`/institution-ranking`, payload);

  return data;
};

export const useCreateInstitutionRanking = () => {
  return useMutation((payload: CreateInstitutionRankingPayload) => {
    return postData(payload);
  });
};
